export default "__VITE_ASSET__CPJJ5qg5__"